"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const form_1 = require("../../atoms/form");
const buttons_1 = require("../../atoms/buttons");
const icons_1 = require("../../atoms/icons");
const form_2 = require("../../molecules/form/form");
const react_i18next_1 = require("react-i18next");
const faSearch_1 = require("@fortawesome/pro-regular-svg-icons/faSearch");
const SearchBar = ({ setSearch, setShowFilters, showFilters }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const onSearch = (e) => {
        e.preventDefault();
        setSearch(e.target.value);
    };
    const onClick = (e) => {
        e.preventDefault();
        setShowFilters();
    };
    return ((0, jsx_runtime_1.jsxs)(Form, { variant: "horizontal", "data-form": "horizontal", showFilters: showFilters, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(form_1.Input, { placeholder: t("sidebar.sidebarHeader.searchPlaceholder"), icon: ["fal", "search"], onChange: onSearch }, void 0), (0, jsx_runtime_1.jsx)("label", { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { icon: faSearch_1.faSearch, shape: "rectangle", color: "lightGrey-transparent", size: "sm" }, void 0) }, void 0)] }, void 0), showFilters ? ((0, jsx_runtime_1.jsx)(buttons_1.Button, { onClick: onClick, "data-cy": "sidebar-toggle-filters", children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", icon: ["fas", "filter"], color: "white" }, void 0) }, void 0)) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0))] }, void 0));
};
exports.SearchBar = SearchBar;
const Form = (0, styled_components_1.default)(form_2.Form) `
  div {
    display: inline-block;
    ${({ showFilters }) => !showFilters ? "margin-right: 0 !important" : ""};
    position: relative;

    & > div {
      ${({ showFilters }) => !showFilters ? "margin-right: 0 !important" : ""};
    }

    label {
      height: 100%;
      margin-bottom: 0;
      position: absolute;
      top: 11px;
      right: ${({ showFilters }) => (showFilters ? 1.5 : 1)}rem;
      z-index: 20;
      pointer-events: none;
      transform: rotateY(180deg);
      transform-origin: 50% 50%;
    }
  }
`;
//# sourceMappingURL=SearchBar.js.map